var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveTeachLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 50,
    viewBox: "0 0 96 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.502 24.6597V26.5575H43.6739L44.855 24.6597H41.502Z",
    fill: "url(#paint0_linear_6130_8054)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6523 26.5575H49.7881V24.6597H46.522C46.0604 24.6597 45.645 24.7901 45.2704 25.048C44.7138 25.4308 44.4369 25.9439 44.4369 26.5874V35.593H46.6523V26.5575Z",
    fill: "url(#paint1_linear_6130_8054)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.563 31.1323V29.2345V29.2318H53.3692V26.5548H59.0082L60.0453 24.657H53.2416C52.78 24.657 52.3646 24.7873 51.99 25.0453C51.4334 25.4281 51.1565 25.9412 51.1565 26.5847V33.6626C51.1565 34.0753 51.2895 34.4554 51.5583 34.8002C51.9791 35.3269 52.5411 35.5903 53.2416 35.5903H60.0453L59.0082 33.6925H53.3692V31.1323H58.563Z",
    fill: "url(#paint2_linear_6130_8054)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6329 34.1405L69.1514 35.593V35.5957H71.5107L68.288 26.4462C67.8292 25.1702 67.0989 24.5294 66.1025 24.5186C65.1034 24.5294 64.3703 25.1702 63.9006 26.4462L60.6915 35.5957H63.0508L66.0998 26.8779L67.9704 32.2427H65.0219L63.8409 34.1405H68.6329Z",
    fill: "url(#paint3_linear_6130_8054)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4873 33.6952C76.0475 33.6952 75.6402 33.5405 75.2656 33.2337C74.728 32.783 74.4592 32.1857 74.4592 31.4364V28.8191C74.4592 28.3114 74.6031 27.8498 74.8909 27.4372C75.2927 26.8534 75.8249 26.5602 76.4873 26.5602H77.9534C78.0294 26.5602 78.1163 26.5657 78.2113 26.5738C78.8059 26.6498 79.2702 26.905 79.6068 27.3367L81.5209 25.8543C81.3091 25.6534 81.0214 25.4607 80.6575 25.2788C79.786 24.8661 78.8847 24.6597 77.9534 24.6597H76.4873C75.3443 24.6597 74.3561 25.0507 73.5225 25.838C72.6782 26.6525 72.2574 27.6462 72.2574 28.8164V31.4336C72.2574 32.5549 72.6565 33.5188 73.452 34.3251C74.2855 35.1695 75.2982 35.5903 76.4873 35.5903H77.9534C78.2792 35.5903 78.6376 35.5523 79.0313 35.4763C80.1553 35.2672 80.9833 34.9061 81.5209 34.3984L79.6068 32.9323C79.5688 32.9785 79.52 33.0328 79.463 33.0898C79.0503 33.4943 78.548 33.6952 77.9534 33.6952H76.4873Z",
    fill: "url(#paint4_linear_6130_8054)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1573 35.593H92.3727H92.3754V24.6597H90.16V29.2345H86.1744L85.4251 30.4291V24.6597H83.2232V35.593H85.4251V31.1323H90.1573V35.593Z",
    fill: "url(#paint5_linear_6130_8054)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79 13.0277C78.5622 13.3293 78.3433 13.7313 78.3433 14.2384V19.803C78.3433 20.1274 78.4482 20.4289 78.658 20.6985C78.9909 21.1142 79.4333 21.3198 79.9806 21.3198H85.321L84.5093 19.8259H80.0855V17.8111H84.1627V16.3172H80.0855V14.2156H84.5093L85.321 12.7216H79.9806C79.6203 12.7216 79.2919 12.8221 79 13.0277Z",
    fill: "url(#paint6_linear_6130_8054)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8311 12.7216H66.1026V21.3198H67.8311V12.7216Z",
    fill: "url(#paint7_linear_6130_8054)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2945 12.7216C61.9342 12.7216 61.6059 12.8221 61.314 13.0277C60.8762 13.3293 60.6572 13.7313 60.6572 14.2384V21.3198H62.3948V14.2156H64.8576V12.7216H62.2945Z",
    fill: "url(#paint8_linear_6130_8054)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9902 12.7216H58.3587V14.2156H60.0644L60.9902 12.7216Z",
    fill: "url(#paint9_linear_6130_8054)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4294 12.6074C44.6449 12.6166 44.0703 13.1191 43.7009 14.1242H43.7054L41.188 21.3198H43.0396L45.4339 14.4669L46.9024 18.6837H44.5856L43.6598 20.1777H47.4178L47.8237 21.3198H49.6753L47.1442 14.1242C46.7839 13.1191 46.2138 12.6166 45.4294 12.6074Z",
    fill: "url(#paint10_linear_6130_8054)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5792 21.3198H54.733L54.7376 21.3244C54.993 21.3244 55.2757 21.2924 55.5858 21.233C56.466 21.064 57.1182 20.7807 57.5378 20.3832L56.0373 19.2274C56.0054 19.2639 55.9689 19.305 55.9233 19.3507C55.5995 19.666 55.2028 19.8259 54.7376 19.8259H53.5837C53.2417 19.8259 52.9179 19.7071 52.626 19.4649C52.2019 19.1132 51.9921 18.6426 51.9921 18.0532V15.9928C51.9921 15.5907 52.1015 15.2298 52.3296 14.9054C52.6488 14.444 53.0638 14.2156 53.5837 14.2156H54.7376H54.7376C54.8014 14.2156 54.8653 14.2156 54.9428 14.2247C55.408 14.2841 55.7728 14.4851 56.0373 14.8232L57.5378 13.6582C57.369 13.4983 57.1456 13.3475 56.8583 13.2059C56.1742 12.8861 55.4673 12.7216 54.7376 12.7216H53.5837C52.6899 12.7216 51.9146 13.0323 51.2578 13.6491C50.5965 14.2887 50.2636 15.0699 50.2636 15.9882V18.0487C50.2636 18.9304 50.5737 19.6888 51.1985 20.3239C51.8507 20.9863 52.6443 21.3198 53.5792 21.3198Z",
    fill: "url(#paint11_linear_6130_8054)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9484 12.7216L71.4796 19.9172C71.8399 20.9223 72.4099 21.4249 73.1944 21.434C73.9788 21.4249 74.5534 20.9223 74.9228 19.9172L77.4403 12.7216H75.5887L73.1944 19.5746L70.8001 12.7216H68.9484Z",
    fill: "url(#paint12_linear_6130_8054)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9918 20.0957H18.4897V30.7165H18.9918C22.3935 30.7165 25.1803 30.6331 25.1803 25.4214C25.1803 20.2097 22.2537 20.0974 18.9918 20.0974V20.0957Z",
    fill: "#1F295C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2173 25.4181C28.2173 30.4034 24.5376 31.0793 18.9894 31.0793H18.4873V35.6984C18.4873 37.8556 18.8967 38.6814 19.6482 38.9964H36.6989L28.4145 24.4953L28.0825 23.9131C28.1701 24.366 28.2173 24.8631 28.2173 25.4148V25.4181Z",
    fill: "#1F295C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7288 35.7879V22.746C15.7288 21.006 15.4137 20.2603 14.3489 20.124L11.8469 24.5031L3.5625 39.0007H14.8274C15.4811 38.6398 15.7288 37.7221 15.7288 35.7862V35.7879Z",
    fill: "#1F295C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9909 19.7304H25.6916L20.1316 10L14.5732 19.7304H18.9909Z",
    fill: "#1F295C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6130_8054",
    x1: 41.502,
    y1: 30.0571,
    x2: 92.3754,
    y2: 30.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6130_8054",
    x1: 41.502,
    y1: 30.0571,
    x2: 92.3754,
    y2: 30.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6130_8054",
    x1: 41.502,
    y1: 30.0571,
    x2: 92.3754,
    y2: 30.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6130_8054",
    x1: 41.502,
    y1: 30.0571,
    x2: 92.3754,
    y2: 30.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6130_8054",
    x1: 41.502,
    y1: 30.0571,
    x2: 92.3754,
    y2: 30.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6130_8054",
    x1: 41.502,
    y1: 30.0571,
    x2: 92.3754,
    y2: 30.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6130_8054",
    x1: 41.188,
    y1: 17.0207,
    x2: 85.321,
    y2: 17.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6130_8054",
    x1: 41.188,
    y1: 17.0207,
    x2: 85.321,
    y2: 17.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6130_8054",
    x1: 41.188,
    y1: 17.0207,
    x2: 85.321,
    y2: 17.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6130_8054",
    x1: 41.188,
    y1: 17.0207,
    x2: 85.321,
    y2: 17.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6130_8054",
    x1: 41.188,
    y1: 17.0207,
    x2: 85.321,
    y2: 17.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6130_8054",
    x1: 41.188,
    y1: 17.0207,
    x2: 85.321,
    y2: 17.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6130_8054",
    x1: 41.188,
    y1: 17.0207,
    x2: 85.321,
    y2: 17.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTeachLogo);
export default __webpack_public_path__ + "static/media/active_teach_logo.b704801f12f342101ec0f8b565107628.svg";
export { ForwardRef as ReactComponent };